module.exports = __webpack_public_path__ + "static/media/bh02.e09bf3fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bh02.jpg
// module id = 377
// module chunks = 0